const dropdownCloseFuncArr = [];
export function ddcSetDropdownCloseFunc(func) {
    let index = dropdownCloseFuncArr.indexOf(func);
    if (index === -1) {
        dropdownCloseFuncArr.push(func);
        console.log('setDropdownCloseFuncArr');
    }
}
export function ddcRemoveDropdownCloseFunc(func) {
    let indexToRemove = dropdownCloseFuncArr.indexOf(func);
    if (indexToRemove !== -1) {
        // Удаляем объект по индексу
        dropdownCloseFuncArr.splice(indexToRemove, 1);
    }
}
export function ddcCloseAllDropdown(func) {
    for (const funcToCall of dropdownCloseFuncArr) {
        if (funcToCall !== func) {
            funcToCall();
        }
    }
}
